module.exports = __webpack_public_path__ + "img/read.b3100345.jpg";